import _everyInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/every";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
var EMPTY = {};
export default function shallowEqual(a, b) {
  if (a === void 0) {
    a = EMPTY;
  }

  if (b === void 0) {
    b = EMPTY;
  }

  var aKeys = _Object$keys(a);

  var bKeys = _Object$keys(b);

  return a === b || aKeys.length === bKeys.length && _everyInstanceProperty(aKeys).call(aKeys, function (key) {
    return a[key] === b[key];
  });
}